module.exports = __webpack_public_path__ + "img/icons.c92ae77c.png";